module.exports = __webpack_public_path__ + "img/245-jersey.0f59ae9f.svg";